import React from "react"

import { useMobileMedia } from "~/hooks/useMobileMedia"

interface Props {
  className?: string
}

const Pc: React.FC<Props> = ({ children, className }) => {
  const isMobile = useMobileMedia()
  if (isMobile) {
    return null
  }
  return <div className={className}>{children}</div>
}

export default Pc
